import React from "react";
import CSSClasses from "./NumericKeyboard.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

import beepMedium from "../../../assets/sounds/beep_medium.mp3";

export const ADJUSTED_FOR_PAYOUT_POPUP = "ADJUSTED_FOR_PAYOUT_POPUP";
export const ADJUSTED_FOR_ADMIN_RESET_ROLL_LENGTH =
  "ADJUSTED_FOR_ADMIN_RESET_ROLL_LENGTH";
export const ADJUSTED_FOR_ENTERING_BET_AMOUNT =
  "ADJUSTED_FOR_ENTERING_BET_AMOUNT";

let buttonInfo = [
  {
    id: 1,
    label: "1",
    value: 1,
    order: 1
  },
  {
    id: 2,
    label: "2",
    value: 2,
    order: 2
  },
  {
    id: 3,
    label: "3",
    value: 3,
    order: 3
  },
  {
    id: 4,
    label: "4",
    value: 4,
    order: 4
  },
  {
    id: 5,
    label: "5",
    value: 5,
    order: 5
  },
  {
    id: 6,
    label: "6",
    value: 6,
    order: 6
  },
  {
    id: 7,
    label: "7",
    value: 7,
    order: 7
  },
  {
    id: 8,
    label: "8",
    value: 8,
    order: 8
  },
  {
    id: 9,
    label: "9",
    value: 9,
    order: 9
  },
  {
    id: 10,
    label: ",",
    value: -1,
    order: 10
  },
  {
    id: 11,
    label: "0",
    value: 0,
    order: 11
  },
  {
    id: 12,
    label: "DEL",
    value: -2,
    order: 12
  }
];

let quickPickButtons = [
  {
    id: 1,
    label: "0,10",
    value: 10,
    order: 1
  },
  {
    id: 5,
    label: "10",
    value: 1000,
    order: 5
  },
  {
    id: 2,
    label: "0,50",
    value: 50,
    order: 2
  },
  {
    id: 6,
    label: "50",
    value: 5000,
    order: 6
  },
  {
    id: 3,
    label: "1",
    value: 100,
    order: 3
  },
  {
    id: 7,
    label: "100",
    value: 10000,
    order: 7
  },
  {
    id: 4,
    label: "5",
    value: 500,
    order: 4
  },
  {
    id: 8,
    label: "200",
    value: 20000,
    order: 8
  }
];

const NumericKeyboard = props => {
  return (
    <div
      className={[
        props.hasQuickPick
          ? CSSClasses.quickPickContainer
          : CSSClasses.container,
        getExtraClassNames(props)
      ].join(" ")}
    >
      <audio
        ref={sound => {
          this.beepMedium = sound;
        }}
      >
        <source src={beepMedium} type="audio/mpeg" />
      </audio>
      <div
        className={[
          CSSClasses.btnClose,
          props.hasQuickPick ? CSSClasses.btnCloseInQuickpick : ""
        ].join(" ")}
        onClick={() => {
          //daj zvukic
          if (this.beepMedium) {
            //daj zvukic
            this.beepMedium.play();
          }

          props.setCurrentlyEditedCombinationID(-1);
          props.closeHandler();
        }}
      >
        POTVRDI
      </div>

      {/* generiraj standardnu */}
      {!props.hasQuickPick ? (
        <div style={{ clear: "both" }}>
          {buttonInfo.map(btn => {
            return (
              <div
                key={btn.id}
                className={CSSClasses.buttonBox}
                onClick={() => {
                  keyboardButton_Click(props, btn.value);
                }}
              >
                {btn.label}
              </div>
            );
          })}
        </div>
      ) : null}

      {/* generiraj s quickpickom */}
      {props.hasQuickPick ? (
        <div className={CSSClasses.doubleContainer}>
          <div className={CSSClasses.leftSectionContainer}>
            <div className={CSSClasses.sectionTitle}>Slobodan unos</div>

            {buttonInfo.map(btn => {
              return (
                <div
                  key={btn.id}
                  className={CSSClasses.buttonBox}
                  onClick={() => {
                    keyboardButton_Click(props, btn.value, false);
                  }}
                >
                  <span className={CSSClasses.tallText}>{btn.label}</span>
                </div>
              );
            })}
          </div>
          <div className={CSSClasses.rightSectionContainer}>
            <div className={CSSClasses.sectionTitle}>Brzi odabir</div>

            {quickPickButtons.map(btn => {
              return (
                <div
                  key={btn.id}
                  className={CSSClasses.quickPickButtonBox}
                  onClick={() => {
                    keyboardButton_Click(props, btn.value, true);
                  }}
                >
                  <span className={CSSClasses.tallText}>
                    {btn.label + props.machineInfo.CurrencyCode}
                  </span>
                </div>
              );
            })}
          </div>

          <div className={CSSClasses.clearFix} />
        </div>
      ) : null}
    </div>
  );
};

const getExtraClassNames = props => {
  if (!props.customClass) {
    return "";
  }

  if (props.customClass === ADJUSTED_FOR_PAYOUT_POPUP) {
    return CSSClasses.adjustedForPayoutPopup;
  }

  if (props.customClass === ADJUSTED_FOR_ADMIN_RESET_ROLL_LENGTH) {
    return CSSClasses.adjustedForAdminResetRoll;
  }

  return "";
};

const handleUpdateComboTicket = (props, value, isQuickPick) => {
  //dohvati stari bet amount
  let oldAmount = 0;
  oldAmount = props.comboBetAmount;

  if (value === -2) {
    //delete!
    props.updateBetAmount(0);

    return;
  }

  if (props.comboBetAmount === 0) {
    oldAmount = "";
  }

  if (isQuickPick) {
    if (oldAmount === "") {
      oldAmount = 0;
    }

    props.updateBetAmount(parseInt(oldAmount, 10) + value);
  } else {
    if (value === -1) {
      //decimala, ako vec ima ili je prazno, ignore
      if (oldAmount === "" || oldAmount.indexOf(".") !== -1) {
        //ignore
        console.log("DOT RETURN");
        return;
      }
      console.log("DOT ADD");
      oldAmount += ".00";
    } else {
      oldAmount += value;
    }

    let newAmount = parseFloat(oldAmount);
    props.updateBetAmount(newAmount);
  }
};

const handleUpdateSystemTicket = (props, value, isQuickPick) => {
  //dohvati stari bet amount
  let oldAmount = 0;

  //dohvati stari bet amount iz sistema
  var system = props.systemCombinations.find(
    x => x.id === props.currentComboTextboxID
  );

  if (system === undefined) {
    //smisli jos
    alert("Undefined system! ", props.currentComboTextboxID);
    return;
  }

  oldAmount = system.betTotal.toString();

  if (value === -2) {
    //delete!
    props.updateCombinationBetAmount(props.currentComboTextboxID, 0);
    return;
  }

  if (system.betTotal === 0) {
    oldAmount = "";
  }

  if (isQuickPick) {
    if (oldAmount === "") {
      oldAmount = 0;
    }

    props.updateCombinationBetAmount(
      props.currentComboTextboxID,
      parseFloat(oldAmount) + value
    );
  } else {
    if (value === -1) {
      //decimala, ako vec ima ili je prazno, ignore
      if (oldAmount === "" || oldAmount.indexOf(".") !== -1) {
        //ignore
        console.log("DOT RETURN");
        return;
      }
      console.log("DOT ADD");
      oldAmount += ".00";
    } else {
      oldAmount += value;
    }

    let newAmount = parseFloat(oldAmount);
    props.updateCombinationBetAmount(props.currentComboTextboxID, newAmount);
  }
};

const keyboardButton_Click = (props, value, isQuickPick) => {
  console.log("CLICK! ", value);

  //daj zvukic
  if (this.beepMedium) {
    //daj zvukic
    this.beepMedium.play();
  }

  // if (props.currentComboTextboxID > 0) {
  //   //iz systema
  //   handleUpdateSystemTicket(props, value, isQuickPick);
  // } else {
  //   handleUpdateComboTicket(props, value, isQuickPick);
  //   //iz obicnog
  // }

  if (props.keyDownHandler) {
    props.keyDownHandler(value, isQuickPick);
  }
};

const mapStateToProps = state => {
  return {
    isShowingNumericKeyboard: state.rrAppState.isShowingNumericKeyboard,
    comboBetAmount: state.rrTicket.betAmount,
    systemCombinations: state.rrTicket.systemCombinations,
    currentComboTextboxID: state.rrTicket.currentlyEditedCombinationID,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeNumericKeyboardVisibility: isShown =>
      dispatch(StoreActions.SetNumericKeyboardVisibility(isShown)),
    setCurrentlyEditedCombinationID: combID =>
      dispatch(StoreActions.SetCurrentlyEditedCombinationID(combID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NumericKeyboard);



// WEBPACK FOOTER //
// ./src/Components/Keyboards/NumericKeyboard/NumericKeyboard.js